import { useScrmFetch } from "@/hooks/common/fetch/useFetch";

// 产品注册接口
export const useProductResgister = async (params = {}) => {
	
	return await useScrmFetch(`/api/gws-ext/cxApi/commit`).post({
        ...params,
	  }).json();
}
  